import { Countdown } from "../../../types";
import { useCountdown } from "../../../hooks/useCountdown";
import Button from "@/components/ui/button";

type ActionButton = {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
};

type Props = {
  countdown: Countdown;
  noBreak?: boolean;
  threshold?: number;
  actionButton?: ActionButton;
};

const CountdownComponent = ({
  countdown,
  noBreak,
  threshold,
  actionButton,
}: Props) => {
  const timeRemaining = useCountdown(countdown);

  const secondsRemaining = (-1 * timeRemaining) / 1000;
  const paddedMinutes = Math.floor(secondsRemaining / 60)
    .toString()
    .padStart(2, "0");
  const paddedSeconds = (Math.floor(secondsRemaining) % 60)
    .toString()
    .padStart(2, "0");

  const timeDisplay =
    threshold !== undefined && secondsRemaining < threshold ? (
      <div className={"animate-countdown-flash"}>
        {paddedMinutes}:{paddedSeconds}
      </div>
    ) : (
      <div>
        {paddedMinutes}:{paddedSeconds}
      </div>
    );

  // Layout with action button (countdown2 style)
  if (actionButton) {
    return (
      <div
        className={
          "relative flex-grow text-center text-xl flex justify-start items-center"
        }
      >
        {timeDisplay}
        <div className={"h-full self-center absolute right-0"}>
          <Button
            className={"text-xl h-full"}
            disabled={actionButton.loading || actionButton.disabled}
            onClick={actionButton.onClick}
          >
            {actionButton.loading ? "loading..." : actionButton.text}
          </Button>
        </div>
      </div>
    );
  }

  // Basic layout without button (original countdown style)
  return (
    <div
      className={"flex-grow text-center self-center text-xl flex justify-start"}
    >
      {timeDisplay}
    </div>
  );
};

export default CountdownComponent;
